<template>
  <div class="d-flex justify-content-between align-items-center mb-3">
    <h2>Meine Abmeldungen</h2>
    <div class="d-flex gap-2">
      <button class="btn btn-outline-secondary" @click="$refs.emailChange.open()">
        <em class="align-middle material-icons">mail</em> E-Mail-Adressen
      </button>
      <button class="btn btn-outline-secondary" @click="selfServiceStore.logout()">
        <em class="align-middle material-icons">logout</em> Ausloggen
      </button>
    </div>
  </div>
  <SelfServiceEmailChange ref="emailChange" @changed="onEmailChanged" />
  <div v-if="windowStatus.is_open" class="alert alert-info py-2 mb-2 small">
    Bitte tragt bis spätestens zum <strong>{{ formatDate(windowStatus.deadline) }}</strong> eure Abmeldungen für den Zeitraum
    <strong>{{ formatDate(windowStatus.period_start) }} – {{ formatDate(windowStatus.period_end) }}</strong>
    hier ein.
    <template v-if="isTouchDevice">
      Über die Kalenderfelder ziehen, um eine Abmeldung zu erstellen. Auf eine Abmeldung tippen, um sie zu bearbeiten oder zu löschen.
    </template>
    <template v-else>
      Über die Kalenderfelder ziehen, um eine Abmeldung zu erstellen. Auf eine Abmeldung klicken, um sie zu bearbeiten oder zu löschen.
    </template>
    <br>
    Für alle Anfragen, die über simple Abmeldungen hinausgehen, wendet euch bitte per E-Mail an <a href="mailto:orga.team@st-mauritius-hattingen.de">orga.team@st-mauritius-hattingen.de</a>.
  </div>
  <div v-else class="alert alert-warning py-2 mb-2 small">
    Das Selbstservice-Fenster ist aktuell geschlossen. Änderungen sind nur durch Administratoren möglich.
    Wendet euch dazu bitte per E-Mail an <a href="mailto:orga.team@st-mauritius-hattingen.de">orga.team@st-mauritius-hattingen.de</a>.
  </div>
  <AbsenceCalendar
    :servers="servers"
    :absences="absenceStore.data"
    :show-sidebar="false"
    :readonly="!windowStatus.is_open"
    :min-date="windowStatus.period_start"
    :max-date="windowStatus.period_end"
    @create="onCreate"
    @update="onUpdate"
    @delete="onDelete"
  />
</template>

<script>
import AbsenceCalendar from "@/components/AbsenceCalendar.vue";
import SelfServiceEmailChange from "@/components/SelfServiceEmailChange.vue";
import {useSelfServiceStore} from "@/stores/selfService";
import {useSelfServiceAbsenceStore} from "@/stores/selfServiceAbsence";

export default {
  name: "SelfServiceAbsences",
  components: {AbsenceCalendar, SelfServiceEmailChange},
  setup() {
    return {
      selfServiceStore: useSelfServiceStore(),
      absenceStore: useSelfServiceAbsenceStore(),
    };
  },
  data() {
    return {
      isTouchDevice: false,
      windowStatus: {is_open: false, period_start: null, period_end: null, deadline: null},
    };
  },
  computed: {
    servers() {
      return this.selfServiceStore.servers.map(s => ({id: s.id, planname: s.name}));
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [y, m, d] = dateStr.split('-');
      return `${d}.${m}.${y}`;
    },
    async onCreate({altarServers, startDate, endDate}) {
      if (!this.windowStatus.is_open) return;
      for (const altarServer of altarServers) {
        await this.absenceStore.addItem({altarServer, startDate, endDate});
      }
      await this.absenceStore.getData();
    },
    async onUpdate(absence) {
      if (!this.windowStatus.is_open) return;
      await this.absenceStore.updateItem(absence);
      await this.absenceStore.getData();
    },
    async onDelete(absence) {
      if (!this.windowStatus.is_open) return;
      await this.absenceStore.deleteItem(absence, false);
      await this.absenceStore.getData();
    },
    async onEmailChanged() {
      await this.absenceStore.getData();
    },
  },
  async mounted() {
    this.isTouchDevice = window.matchMedia('(pointer: coarse)').matches;
    this.absenceStore.getData();
    const response = await this.axios.get('/selfservice/window/');
    this.windowStatus = response.data;
  },
};
</script>
